import React, {useState } from "react";
import HsnFinder from "@/component/shared/hsn/hsnFindercommon";
import { ENDPOINTS, WEB_URL } from "@/config/endpoints";
import axios from "axios";
import Link from "next/link";
import dynamic from 'next/dynamic';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import Head from 'next/head';
import { getHSNSearchBreadcrumbSchema } from "@/lib/hsnSearchBreadcrumbSchema";
import useIsMobile from "@/shared/useIsMobile";
import HSNsearch_config from "@/config/hsnSearch_config";

const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
  loading: () => <p>Loading...</p>
})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
  loading: () => <p>Loading...</p>
})

const searcKeyword = ({ id, hsnKeywords, interLinkChapters }) => {
  const [showNextStep, setShowNextStep] = useState(false);
  const moreHsns = interLinkChapters;
  const isMobile = useIsMobile();

  const showSteps = () => {
    setShowNextStep(true)
  }
  const showFirstStep = () => {
    setShowNextStep(false)
  }

  function textCapitalized(value) {
    if (value != null) {
      const loweredCase = value.toLowerCase();
      return value[0].toUpperCase() + loweredCase.slice(1);
    }
  }
  const formatSlugToName = (slug) => {
    return {
      id: slug,
      name: slug
        ?.split("-")
        ?.map((word) =>
          word.charAt(0).toUpperCase() + word.slice(1)
        )
        ?.join(" "),
    };
  };
  const titleName = formatSlugToName(id).name;

  const breadcrumbSchema = getHSNSearchBreadcrumbSchema({
    keywordName: titleName,
    keywordSlug: id,
  });

  return (
    <main>
      <Head>
        <title>{titleName + " HSN Code with GST Rates"}</title>
        <meta name="description" content={"Get the correct HSN code for " + titleName +" with GST rate, product description, and classification details."} />
        {/* OpenGraph tags */}
        <meta property="og:title" content={titleName +" HSN Code with GST Rates"} />
        <meta property="og:description" content={"Get the correct HSN code for " + titleName +" with GST rate, product description, and classification details."} />
        <meta property="og:url" content={WEB_URL + '/hsn-code/search/' + id} />
        <link rel="canonical" href={WEB_URL + '/hsn-code/search/' + id} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
      </Head>
      <HsnFinder />
      <section className="bg-white py-20">
          <div className="container px-3 xm:px-2 lg:px-3">
            <div className="flex flex-wrap">
              <div className="w-[63%] md:w-full sm:w-full pr-4 sm:pr-0 md:pr-0">
                <div className="mb-5">
                  <p className="text-sm text-secondary mb-3 capitalize">
                    <Link href={WEB_URL} rel="noopener noreferrer">
                      <span
                        className="text-[#2369d8] cursor-pointer font-sm">
                        {" "}
                        Home {"  "}
                      </span>
                    </Link>
                    {"  "}{" > "}
                    <Link href={WEB_URL+`/hsn-code/search`} rel="noopener noreferrer">
                      <span
                        className="text-[#2369d8] cursor-pointer font-sm">
                        {" "}
                        HSN Codes List {"  "}
                      </span>
                    </Link>
                    {" > "} {titleName}
                    <span className="font-bold">{ }</span>
                  </p>
                    <h1 className="text-base text-secondary">
                    List of HSN Code for <strong className="font-bold capitalize">{titleName}</strong>
                    </h1>
                </div>
                {!isMobile ?
                  <div className="mt-8 flow-root">
                    <div className="overflow-x-auto flex flex-wrap">
                        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                          <table className="min-w-full table-fixed w-full">
                            <thead className="bg-gray-50">
                              <tr className="bg-[#B5B5B5] rounded-t-lg">
                                <th
                                  scope="col"
                                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 w-[15%]"
                                >
                                  HSN Code
                                </th>
                                <th
                                  scope="col"
                                  className="px-3 py-3 text-left text-sm font-semibold text-gray-900 w-[30%]"
                                >
                                  Description
                                </th>
                                <th
                                  scope="col"
                                  className="px-2.5 py-3 text-left text-sm font-semibold text-gray-900 w-[12%] min-w-[110px]"
                                >
                                  GST Rate
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white">
                              {hsnKeywords.map((hsn, index) => (
                                <tr className="odd:bg-[#F5F9FC]" key={index}>
                                  <td
                                    style={{ width: "150px" }}
                                    className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                                  >
                                    <Link className='text-anchor-blue hover:text-yellowcolor hover:underline' href={WEB_URL+`/hsn-code/${hsn.hsn}`}>{hsn.hsn}</Link>
                                  </td>
                                  <td className="whitespace-wrap px-3 py-4 text-sm text-gray-500 w-[30%] break-words">
                                    {textCapitalized(hsn.descriptionString)}
                                  </td>
                                  <td className="whitespace-wrap px-3 py-4 text-sm text-gray-500">
                                    {hsn.gstRate != null && hsn.gstRate != undefined ? hsn.gstRate + " %" : "--"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                  :
                    <div className="mx-auto sm:w-auto mb-8">
                      {hsnKeywords.map((hsn,index) => {
                        return (
                          <div key={index}>
                            <div className="mt-3 odd:bg-[#F5F9FC] p-2">
                              <div className="flex item-center pb-xsp">
                                <span className="text-sm text-secondary font-bold mr-2">
                                  HSN Code :
                                </span>
                                <span className="text-sm text-secondary font-bold mr-2">
                                  <Link className='text-secondary hover:text-yellowcolor hover:underline'href={WEB_URL+`/hsn-code/${hsn.hsn}`}>{hsn.hsn}</Link>
                                </span>
                              </div>

                              <div className="flex item-center pb-xsp">
                                <span className="text-sm text-secondary">
                                  {" "}
                                  {textCapitalized(hsn.descriptionString)}
                                </span>
                              </div>
                              <div className="flex item-center pb-xsp">
                                <span className="text-sm text-secondary font-bold mr-2">
                                  GST Rate :
                                </span>
                                <span className="text-sm text-secondary">
                                  {hsn.gstRate != null && hsn.gstRate != undefined ? hsn.gstRate + " %" : "--"}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                }
                <p className="mt-6 flex items-start gap-x-xsp text-base sm:text-sm text-baseBlack bg-[#FFFFE0] border border-gray p-2 sm:p-1 rounded-xl">
                  <svg
                    xmlns="https://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="mt-0.5 shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M12 6C12.8284 6 13.5 5.32843 13.5 4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 11 6ZM9 10H11V18H9V20H15V18H13V8H9V10Z" />
                  </svg>
                  <span>
                    <strong>Disclaimer:</strong> All the aforementioned GST rates against
                    various HSN codes are sourced from publicly available notifications,
                    notices, and rate schedules issued by the Central Board of Indirect Taxes
                    and Customs (CBIC), Government of India. This data is updated periodically
                    and was last verified in September 2025. There may be chances of variation
                    in tax rates based on product specification, applicable exemption, intended
                    use, and any subsequent amendments to GST laws. This information is
                    provided as a general reference tool only and Credlix makes no
                    representation or warranty regarding the accuracy or completeness of this
                    data. In case of any discrepancy, users are advised to verify the latest
                    GST applicability from the official{" "}
                    <Link
                      href="https://cbic-gst.gov.in/gst-goods-services-rates.html"
                      className="text-anchor-blue underline-offset-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      CBIC website
                    </Link>
                    .
                  </span>
                  </p>
                 <div className="w-full pt-6 sm:pt-4">
                        <h3 className="font-medium text-lg mb-3">HSN Code Chapters</h3>
                        <ul className="flex flex-wrap">
                          {moreHsns.map((data, index) => (
                            <li key={index} className="first:pl-0 relative text-sm  after:content-['|'] after:px-2 sm:after:px-[5px] last:after:content-[''] after:text-sm mb-2"><Link className='text-secondary hover:text-yellowcolor hover:underline' href={data.chapterLink}>Chapter {data.chapter}</Link></li>
                          ))}
                        </ul>
                  </div>
              </div>
              <div className="w-[36%] md:w-full sm:w-full">
                <div className='lg:sticky xm:sticky md:mt-5 lg:top-[130px] xm:top-[100px]'>
                  <div className='mb-1 sm:hidden block'>
                    <FormProvider>
                      {!showNextStep ?
                        <ContactFormStep1 showStep1={showSteps} /> :
                        <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew" />
                      }
                    </FormProvider>
                  </div>
                  <Link href={ENDPOINTS.DOMESTIC_MEETING_SCHEDULER} className='hover:underline flex gap-xsp justify-center items-center' target="_blank">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="brand" className='fill-brand'><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z"></path></svg>
                      <p className='text-base2 font-medium text-brand'>Book a meeting</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
      </section>
    </main>
  );
};
export default searcKeyword;

export async function getServerSideProps(context) {
    const { res } = context;
    const id = context.params.searcKeyword;
    if (HSNsearch_config.includes(id)) {
      return {
        notFound: true,
      };
    }
    let hsnKeywords = [];
    let interLinkChapters = [];

    let config = {
      url: `${ENDPOINTS.HSN_KEYWORDS_LIST_DETAIL_API}/${id}?page=1&limit=1000`,
      headers: {
        "Content-Type": "application/json",
      },
    };  
    try {
      const response = await axios(config);
      if (!response.data.result || response.data.result.length === 0) {
        return {
          notFound: true,
        };
      }  
      hsnKeywords = response.data.result.map(item => ({
        hsn: item.hsn,
        descriptionString: item.descriptionString,
        gstRate: item.gstRate,
        chapter: item.chapter
      }));
      interLinkChapters = [...new Set(response.data.result.map(item => item.chapter))].map((chapter) => ({
        chapter: chapter,
        chapterLink: `${WEB_URL}/hsn-code/chapter/${chapter <= 9 ? '0' : ''}${chapter}`,
      }));
    } catch (err) {
      res.statusCode = 500;
      return {
        notFound: true,
      };
    }
    return {
      props: {
        id,
        hsnKeywords,
        interLinkChapters
      },
    };
  }